import { Gallery } from "./gallery";
import { Images } from "./Images";

export const categoryDetailsByPath = {
  "/competition/VirtualRobot": {
    title: "Virtual Robot",
    type: "Engineers & Pioneers",
    image: Images.main2,
    brief:
      "In the Virtual Robot Challenge, students aged 6 to 12 will use Livit Studio to program a simulated robot to complete a series of digital tasks within a virtual environment. This challenge emphasizes creativity, logical thinking, and precise programming as participants work to solve problems and guide their robot through various challenges. With a focus on virtual robotics, it provides an accessible and engaging introduction to robotics and coding, helping young learners build essential skills in computational thinking, planning, and digital control—all within a fun and educational setting.",
    specsTitle: "Virtual Robot Category",
    specs: [
      { label: "Age", value: "6 - 12" },
      { label: "Team size", value: "1-2 people guided by a coach" },
      { label: "Software", value: "Livit Studio" },
    ],
    downloads: [
      {
        label: "Download Detailed Rules (PDF)",
        href: "https://drive.google.com/uc?export=download&id=1-gymIyAXLjD-KlpFUpr9bbTyUyBz8ID2",
        download: true,
      },
      {
        label: "Download Livit Studio Software",
        href: "https://livitstudio.io/download/",
        external: true,
      },
    ],
    gallery: [
      Gallery.gallery18,
      Gallery.gallery55,
      Gallery.gallery4,
      Gallery.gallery3,
      Gallery.gallery2,
      Gallery.gallery1,
      Gallery.gallery15,
    ],
  },
  "/competition/Robomission": {
    title: "Robo Mission",
    type: "Engineers & Pioneers",
    image: Images.wedo,
    brief:
      "In the Robo Mission Challenge, teams will design, build, and program a robot capable of completing specific tasks on the competition field. Using the WeDo 2.0 Kit, Spike Essential Kit, or an open kit, participants are encouraged to showcase their creativity and technical skills. The goal is to complete as many tasks as possible within a 3-minute time limit, with each task earning points based on its complexity and completion. The game field features a variety of challenges, such as moving objects, navigating obstacles, and triggering mechanisms, all designed to test precision, speed, and programming logic. This challenge is an exciting opportunity for participants to combine engineering, problem-solving, and time management in a competitive and creative environment!",
    specsTitle: "Robo Mission Category",
    specs: [
      { label: "Age", value: "6 - 10" },
      { label: "Team size", value: "2-5 people guided by a coach" },
      {
        label: "Hardware",
        value:
          "The controllers, motors and sensors used can be from LEGO education products or any tool Set",
      },
      { label: "Maximum size", value: "Max. 20 x 20 x 25 cm" },
    ],
    subCategories: {
      title: "The category is divided into 3 sub-categories",
      items: [
        "Robo Mission Spike (using Lego Spike Essensial Kit)",
        "Robo Mission Wedo (using Lego Wedo Kit)",
        "Robo Mission Open (using any type of kit)",
      ],
    },
    downloads: [],
    gallery: [
      Gallery.gallery18,
      Gallery.gallery55,
      Gallery.gallery4,
      Gallery.gallery3,
      Gallery.gallery2,
      Gallery.gallery1,
      Gallery.gallery15,
    ],
  },
  "/competition/RobomissionKids": {
    title: "Robo Mission",
    type: "Researchers",
    image: Images.main4,
    brief:
      "In the challenge, young engineers will design and build a robot to complete fun and simple tasks in the competition field. Kids can let their imaginations shine using an open kit while learning basic robotics skills. The goal is to complete the mission accurately within the 2-minute time limit. Tasks are designed to be engaging and age-appropriate, such as delivering objects, sorting objects, or triggering simple mechanisms. These challenges encourage kids to explore robotics playfully, helping them develop problem-solving, teamwork, and creativity. This friendly and supportive competition introduces young participants to the exciting world of robotics in a fun and inspiring environment, giving them the confidence to build, learn, and succeed!",
    specsTitle: "Robo Mission Category",
    specs: [
      { label: "Age", value: "4 - 6" },
      { label: "Team size", value: "2-5 people guided by a coach" },
      {
        label: "Hardware",
        value:
          "The controllers, motors and sensors used can be from LEGO education products or any tool Set",
      },
      { label: "Maximum size", value: "Max. 15 x 15 cm" },
    ],
    downloads: [
      {
        label: "Download Detailed Rules (PDF)",
        href: "https://drive.google.com/uc?export=download&id=1rTRMwceftWnUfZHMjoNX--8_Ly-PKBQO",
        download: true,
      },
      {
        label: "Download Printable Mat",
        href: "https://drive.google.com/uc?export=download&id=1mXrjpar_H8tVnlnLqMT_w4YrSVhRMadG",
        download: true,
      },
      {
        label: "Rules Video",
        href: "https://www.youtube.com/shorts/rrt2z6oBgSY",
        external: true,
      },
    ],
    gallery: [
      Gallery.gallery18,
      Gallery.gallery55,
      Gallery.gallery4,
      Gallery.gallery3,
      Gallery.gallery2,
      Gallery.gallery1,
      Gallery.gallery15,
    ],
  },
  "/competition/Followline": {
    title: "Line Follower",
    type: "Engineers & Pioneers",
    image: Images.follow,
    brief:
      "In this category, teams will design and program robots to autonomously navigate a line track from the starting point to the end of the line. The robots must use sensors, such as Colour sensors or IR sensors, to detect and follow the line accurately. The challenge is a race between two teams navigating the same line on parallel tracks, adding excitement and competition. Creativity in robot design and coding strategies is highly encouraged as each team strives for a smooth and efficient run. Teams that navigate the line faster will emerge as winners. This category is an excellent way to explore programming logic and sensor integration while fostering teamwork, strategic thinking, and competitive spirit!",
    specsTitle: "Line Follower Category",
    specs: [
      { label: "Age", value: "6 - 10" },
      { label: "Team size", value: "2-5 people guided by a coach" },
      {
        label: "Hardware",
        value:
          "The controllers, motors and sensors used can be from LEGO education products or any tool Set",
      },
      { label: "Maximum robot size", value: "Max. 20 x 20 x 25 cm" },
    ],
    subCategories: {
      title: "The category is divided into 3 sub-categories",
      items: [
        "Line Follower Spike (using Lego Spike Essensial Kit)",
        "Line Follower Wedo (using Lego Wedo Kit)",
        "Line Follower Open (using any type of kit)",
      ],
    },
    downloads: [
      {
        label: "Download Detailed Rules (PDF)",
        href: "https://drive.google.com/uc?export=download&id=1cYMus0A0DnyzDoqLaTDdpQKWS9VDNCy7",
        download: true,
      },
      {
        label: "Line Follower Mat (PDF)",
        href: "https://drive.google.com/uc?export=download&id=1Om3ZhnkLHAlZy9Il_01BwjEdwyaUVsI4",
        download: true,
      },
    ],
    gallery: [
      Gallery.gallery6,
      Gallery.gallery10,
      Gallery.gallery9,
      Gallery.gallery11,
      Gallery.gallery12,
      Gallery.gallery42,
      Gallery.gallery46,
    ],
  },
  "/competition/roboGuard": {
    title: "Robo Guard",
    type: "Engineers & Pioneers",
    image: Images.robogaurd,
    brief:
      "The Robo Garud Category is an exciting challenge where teams design and program their own guardian robots to protect their towers in a thrilling arena! Each team builds a robot to guard their tower while trying to challenge and disrupt the opponent team's defense. The objective is to keep your tower safe from the opposing team's robot while attempting to disrupt their defense and score points. Robots can be autonomous, manually controlled, or a combination of both, allowing teams to showcase their creativity and technical skills. This fun and dynamic challenge inspires young minds to think critically, work together, and apply engineering principles in a competitive yet enjoyable setting, making the Tower Defense Challenge a favorite among participants!",
    specsTitle: "Robo Guard Category",
    specs: [
      { label: "Age", value: "6 - 10" },
      { label: "Team size", value: "2-5 people guided by a coach" },
      {
        label: "Hardware",
        value:
          "The controllers, motors and sensors used can be from Wedo 0.2 or Spike essential kits only",
      },
      { label: "Maximum robot size", value: "Max. 15 x 15cm, Max Weight 0.5kg" },
    ],
    downloads: [
      {
        label: "Download Detailed Rules (PDF)",
        href: "https://drive.google.com/uc?export=download&id=1TSHGe1mmwleHy9782_h_9OSKHiewJ4kj",
        download: true,
      },
      {
        label: "Robo Guard Mat (PDF)",
        href: "https://drive.google.com/uc?export=download&id=18jRxopJQNqBfo6ZyPkac9Ugi8p6-Jhx0",
        download: true,
      },
    ],
    gallery: [
      Gallery.gallery18,
      Gallery.gallery19,
      Gallery.gallery39,
      Gallery.gallery24,
    ],
  },
  "/competition/Researchers": {
    title: "Scientific Project",
    type: "Researchers",
    image: Images.rec,
    brief:
      "In this category, little explorers aged 4 to 6 become young scientists, diving into a fun and exciting theme that sparks their curiosity and creativity. With the help of their coaches and teammates, they identify a simple problem related to the theme and devise an imaginative solution using technology. Kids get hands-on by building a colorful model to show off their ideas and learning through play and teamwork. They also practice explaining their project in simple terms and sharing their ideas with others. This challenge is all about exploring, creating, and having fun while building confidence and communication skills. It's a wonderful opportunity for young minds to discover the joy of learning, think like little scientists, and proudly share their big ideas!",
    specsTitle: "Scientific Project Category",
    specs: [
      { label: "Age", value: "4 - 6" },
      { label: "Team size", value: "2-5 people guided by a coach" },
      {
        label: "Model and poster required",
        value: "teams can build their model using any tool kit",
      },
    ],
    downloads: [
      {
        label: "Download Detailed Rules (PDF)",
        href: "https://drive.google.com/uc?export=download&id=128A_D6DbH2G_8O8u3LxMpyktCFij_GoJ",
        download: true,
      },
    ],
    gallery: [
      Gallery.gallery56,
      Gallery.gallery50,
      Gallery.gallery59,
      Gallery.gallery51,
    ],
  },
  "/competition/Scientific": {
    title: "Scientific Project",
    type: "Engineers & Pioneers",
    image: Images.wedo2,
    brief:
      "In the Scientific Project Challenge, kids transform into young researchers, exploring a year-long theme that sparks curiosity and innovation. Participants identify a real-world problem related to the theme, dive deep into research to understand it, and invent a creative solution using technology. The challenge emphasizes hands-on learning and critical thinking as kids design and build a model to demonstrate their solution. Alongside their model, they prepare a presentation to showcase their research journey, explaining their findings, thought process, and how their invention addresses the problem. This challenge encourages kids to explore the world around them, think like scientists, and unleash their creativity while gaining valuable skills in research, problem-solving, and communication. It's a fantastic opportunity to learn, create, and share ideas!",
    specsTitle: "Scientific Project Category",
    specs: [
      { label: "Age", value: "6 - 10" },
      { label: "Team size", value: "2-5 people guided by a coach" },
      { label: "Model and poster required", value: "use any tools" },
    ],
    downloads: [
      {
        label: "Download Detailed Rules (PDF)",
        href: "https://drive.google.com/uc?export=download&id=1WD3ZeiH2uSuFlHK7ONVsvDtGzIcf1aBF",
        download: true,
      },
    ],
    gallery: [
      Gallery.gallery56,
      Gallery.gallery50,
      Gallery.gallery59,
      Gallery.gallery51,
    ],
  },
};

export const getCategoryDetail = (pathname) =>
  categoryDetailsByPath[pathname] ?? null;
